import type { FC, PropsWithChildren } from 'react';

import { listStyle } from './BulletList.css';
import { getClassNames } from '../../util/css';

type CompoundBulletListProps = {
  Item: typeof Item;
};

export type BulletListProps = PropsWithChildren<{
  className?: string;
}>;

export const BulletList: FC<BulletListProps> & CompoundBulletListProps = ({ children, className }) => {
  return <ul className={getClassNames(listStyle, className)}>{children}</ul>;
};

export type BulletListItemProps = PropsWithChildren<{
  className?: string;
}>;

const Item: FC<BulletListItemProps> = ({ children, className }) => {
  return <li className={className}>{children}</li>;
};

BulletList.Item = Item;
BulletList.displayName = 'BulletList';
